module.exports = __webpack_public_path__ + "img/basic-level.d0804d3a.png";